import { Box, Checkbox, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import { API_GET, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";
const PAGE_SIZE_OPTIONS = [15];

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ContactUsScreen = () => {
  const [data, setData] = useState();
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowId",
      headerName: "#",
      width: 50,
      headerAlign: "center",
      renderCell: (cell) => {
        return cell?.row?.rowId + page * PAGE_SIZE_OPTIONS;
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "full_name",
      headerName: "User Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },

    {
      headerClassName: "super-app-theme--header",
      field: "phno",
      headerName: "Number",
      width: 200,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "subject",
      headerName: "Subject",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "message",
      headerName: "Description",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "is_Active",
      headerName: "Action",
      width: 200,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Checkbox
              {...label}
              style={{ color: "#F57C00" }}
              onChange={() => handleContactAction(cell?.row)}
              checked={cell?.row?.is_followup}
            />
          </Box>
        </Box>
      ),
    },
   
  ];

  const handleContactAction = async (data) => {
    try
    {
      const f = new FormData();
      f.append("id", data?.id);
      f.append("is_followup", data?.is_followup === 1 ? 0 : 1);

      const res = await API_POST(API_endspoints.UpdateContactFollowUp, f);
      if (res?.s)
      {
        toast.success(res?.m);
        FetchContactData();
      }
    } catch (error)
    {
      console.log(error);
    }
  };

  const FetchContactData = async (
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0]
  ) => {
    try
    {
      setIsLoading(true);
      let count = page * pageSize;
      const res = await API_GET(
        `${API_endspoints.GetContactList}?count=${count}&offset=${pageSize}`
      );
      if (res && res?.s)
      {
        const RowData = res?.r?.map((x, i) => {
          return {
            rowId: i + 1,
            ...x,
          };
        });
        setData(RowData);
        setTotalData(res?.c ?? 0);
      } else
      {
        setData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error)
    {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    FetchContactData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          Contact Us
        </Typography>
      </Box>
      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 130px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
    </Box>
  );
};

export default ContactUsScreen;
